module.exports = __webpack_public_path__ + "static/media/progress.506b04fd.png";